import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    ROUTE_TO_CAMBIO_CONTRASENA,
    RESET_PASSAWORD_CHANGE,
    LOGIN_SET_CONFIG,
    ESCONDER_POPUP_LOGIN
} from '../../Screens/Login/actions/Actions';
import { LOGOUT } from '../../Screens/TopMenu/Actions';

const initialState = {
    loggedIn: false,
    isFetching: false,
    error: false,
    errorMessage: "",
    passwordChange: false,
    passwordChangeUser: 0,
    executionContext: null,
    userId: null,
    configSession: {},
    adUserLogin: "",
    expirationTime: null,
    adUserGroup: null
}

export function sesion( state = initialState, action ) {
    LogHelper.In( sesion.name, state, action );

    switch ( action.type ) {
        /* INICIAR SESION */
        case LOGIN_START:
            LogHelper.Out( sesion.name );
            return { ...state, isFetching: true };

        /* INICIO DE SESION EXITOSO */
        case LOGIN_SUCCESS:
            LogHelper.Out( sesion.name );
            return {
                ...state,
                isFetching: false,
                executionContext: action.executionContext,
                userId: action.userId,
                configSession: action.configSession,
                expirationTime: action.expirationTime,
                loggedIn: true,
                adUserGroup: action.adUserGroup
            };

        /* INICIO DE SESION FALLIDO */
        case LOGIN_FAIL:
            LogHelper.Out( sesion.name );
            return { ...state, isFetching: false, error: true, errorMessage: action.data, loggedIn: false };

        /* CERRAR SESION */
        case LOGOUT:
            LogHelper.Out( sesion.name );
            return initialState;

        /* CAMBIO DE CONTRASEÑA */
        case ROUTE_TO_CAMBIO_CONTRASENA:
            LogHelper.Out( sesion.name );
            return {
                ...state,
                passwordChange: true,
                passwordChangeUser: action.data.userId,
                isFetching: false
            };

        /* REINICIO EL ESTADO DEL PASSWORD  */
        case RESET_PASSAWORD_CHANGE:
            LogHelper.Out( sesion.name );
            return {
                ...state,
                passwordChange: false
            };

        /* SETEA CONFIGURACIÓN DE SESIÓN */
        case LOGIN_SET_CONFIG:
            LogHelper.Out( sesion.name );
            return {
                ...state,
                configSession: action.data,
                adUserLogin: action.adUserLogin,
                isFetching: false
            };

        /*ESCONDE POP UP DE ERROR*/
        case ESCONDER_POPUP_LOGIN:
            LogHelper.Out( sesion.name );
            return {
                ...state,
                error: false,
                errorMessage: ""
            };

        default:
            LogHelper.Out( sesion.name );
            return state;
    }
}

export default sesion;


// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/Sesion.js